import {message} from 'ant-design-vue';

const antMessage = message;

export default antMessage;
